<template>
    <div class="flex flex-col gap-7" />
</template>

<script setup lang="ts">
    import { useNavigationStore } from '~/stores/navigationStore';

    const store = useNavigationStore();
    if (!store.currentNavigationLevel) {
        showError({ statusCode: 404, name: 'No menu items' });
    }
</script>
